import { useTeamCreateTournamentCalendarId } from './useTeamCreateTournamentCalendarId';
import { getPeriodLabels, periodAxisFromFormat, type PeriodLabels } from '@/lib/periodLabels';

/**
 * The scoring period's wording for the active tournament — "Gameweek"/"GW" on
 * a season-long competition, "Matchday"/"MD" on the World Cup.
 *
 * Reads the active tournament calendar's format, so any surface that is not
 * already scoped to a specific calendar can name the period correctly without
 * its own query. Surfaces that render a *particular* board (league detail, the
 * leaderboard, a player's history) should keep deriving the axis from that
 * board's own `leaderboard-periods` response instead — the tournament being
 * viewed there is not necessarily the active one.
 */
export const usePeriodLabels = (): PeriodLabels => {
  const { format } = useTeamCreateTournamentCalendarId();

  return getPeriodLabels(periodAxisFromFormat(format));
};
